module.exports = "/img/videos/8.dedbf6.mp4";